Nette.initOnLoad();

function flashFadeOut()
{
    $('#flashMessagesBox').children('.alert').delay(7000).fadeOut(3000);
}

$(function()
{
    'use strict';

    flashFadeOut();

    $.nette.ext('flash', {
        complete: flashFadeOut
    });
    $.nette.init();

    $.fn.whisperer = function () {
        var disallowedKeyArray = [13, 37, 38, 39, 40];
        this.each(function () {
            var element = $(this);

            var chosenId = (element.attr('id') + '_chosen').replace(/-/g, "_");
            var searchInput = $('#' + chosenId).find('input.chosen-search-input');
            var varUrlOnChange = element.data('whisperer');
            var varUrlOnSelect = element.data('whisperer-onselect');
            var delay = element.data('whisperer-delay');
            var typingTimer;

            if (typeof varUrlOnSelect !== 'undefined') {
                //Run onselect after pressing enter
                searchInput.on('keyup', function (event) {
                    if ((event.keyCode || event.which) === 13) {
                        $.nette.ajax({
                            method: 'GET',
                            url: varUrlOnSelect,
                            data: {selected: element.val()}
                        });
                    }
                });

                var resultField = $('#' + chosenId).find('ul.chosen-results');

                resultField.on('click', function () {
                    $.nette.ajax({
                        method: 'GET',
                        url: varUrlOnSelect,
                        data: {selected: element.val()}
                    });
                });
            }

            if (typeof varUrlOnChange !== 'undefined') {
                //loading
                element.on('chosen:no_results', function () {
                    $('#' + chosenId).find('li.no-results').html('<span class="color-black"><i class="fas fa-spinner fa-spin"></i>&nbsp;&nbsp;Načítají se položky</span>');
                });

                searchInput.keydown(function (event) {
                    var code = (event.keyCode || event.which);

                    if (jQuery.inArray(code, disallowedKeyArray) === -1) {
                        clearTimeout(typingTimer);
                        typingTimer = setTimeout(function () {
                            var param = searchInput.val();

                            $.nette.ajax({
                                url: varUrlOnChange,
                                type: "POST",
                                dataType: "json",
                                data: {param: param}
                            }).done(function (response) {
                                var empty = true;
                                element.empty();

                                $.each(response.suggestions, function (index, el) {
                                    if (el.data !== "") {
                                        empty = false;
                                    }

                                    element.append("<option value=" + el.data + ">" + el.value + "</option>");
                                });

                                element.trigger("chosen:updated");

                                if (empty === true) {
                                    $('#' + chosenId).find('ul.chosen-results').append('<li class="no-results">Nebyla nalezena žádná položka - ' + param + '</li>');
                                }
                                searchInput.val(param);
                            });
                        }, delay);
                    }
                });
            }
        });
    };

    $('[data-toggle="tooltip"]').tooltip();
    $('select[data-dependentselectbox]').dependentSelectBox();
    $('.date-picker').datepicker({format: "dd.mm.yyyy", todayHighlight: true, orientation: 'bottom left'});
    $('.date-picker').attr('autocomplete', 'off');
    $('[data-toggle="popover"]').popover();
    $('.custom-file input').change(function (e) {
        var files = [];
        for (var i = 0; i < $(this)[0].files.length; i++) {
            files.push($(this)[0].files[i].name);
        }
        $(this).next('.custom-file-label').html(files.join(', '));
    });
    $('.form-control-chosen').chosen({
        allow_single_deselect: true,
        no_results_text: "Nebyla nalezena žádná položka - ",
        width: '100%'
    });

    $('.form-control-chosen-required').chosen({
        allow_single_deselect: false,
        no_results_text: "Nebyla nalezena žádná položka - ",
        width: '100%'
    });

    $('[data-whisperer], [data-whisperer-onselect], [data-whisperer-delay]').whisperer();

    $('.wysiwyg').summernote({
        lang: 'cs-CZ'
    });
});

/**
 * After ajax we need refresh whisperer options
 */
$(document).ready(function ()
{
    $.nette.ext('snippets').after(function (el)
    {
        $('.date-picker').datepicker({format: "dd.mm.yyyy", todayHighlight: true, orientation: 'bottom left'});
        $('.date-picker').attr('autocomplete', 'off');
        $('[data-toggle="tooltip"]').tooltip();
        $('select[data-dependentselectbox]').dependentSelectBox();
        $('[data-toggle="popover"]').popover();
        $('.custom-file input').change(function(e){
            var files = [];
            for (var i = 0; i < $(this)[0].files.length; i++) {
                files.push($(this)[0].files[i].name);
            }
            $(this).next('.custom-file-label').html(files.join(', '));
        });
        $('.form-control-chosen').chosen({
            allow_single_deselect: true,
            no_results_text: "Nebyla nalezena žádná položka - ",
            width: '100%'
        });

        $('.form-control-chosen-required').chosen({
            allow_single_deselect: false,
            no_results_text: "Nebyla nalezena žádná položka - ",
            width: '100%'
        });
        $('[data-whisperer], [data-whisperer-onselect], [data-whisperer-delay]').whisperer();

        $('.wysiwyg').summernote({
            lang: 'cs-CZ'
        });
    });
});

/**
 * @return {boolean}
 */
Nette.validators.SitmpComponentFormValidator_greater = function(elem, args, val)
{
    return parseInt(val) > parseInt(args);
};

/**
 * @return {boolean}
 */
Nette.validators.SitmpComponentFormValidator_less = function(elem, args, val)
{
    return parseInt(val) < parseInt(args);
};

/**
 * @return {boolean}
 */
Nette.validators.SitmpComponentFormValidator_sameLength = function(elem, args, val)
{
    return args.length === val.length;
};